/* Builds Colour / Finish / Size option rows from assets/tile-variants.json */
(function () {
  'use strict';
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  /* Use the original flat photo (ORIG-… in Files) instead of the hand-held product shot */
  function orig(url) {
    var m = String(url || '').match(/^(.*\/files\/)(CW-[^/?]+)-hand(\.[a-z0-9]+)(\?.*)?$/i);
    return m ? m[1] + 'ORIG-' + m[2] + m[3] : url;
  }
  function thumb(url) {
    if (!url) return '';
    url = orig(url);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    try { var u = new URL(url); u.searchParams.set('width', '160'); return u.toString(); } catch (e) { return url; }
  }
  document.querySelectorAll('[data-tile-options]').forEach(function (box) {
    var handle = box.dataset.handle;
    fetch(box.dataset.src, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      if (!d) return;
      var i = d.h.indexOf(handle);
      if (i < 0 || !d.r[i] || !d.r[i].length) return;
      var html = '';
      var swatchJobs = [];
      d.r[i].forEach(function (row) {
        var name = d.n[row[0]], cur = d.v[row[1]], isColour = /^colou?r$/i.test(name);
        html += '<div class="topt"><p class="topt__label">' + esc(name) + ': <strong>' + esc(cur) + '</strong></p><div class="topt__list" role="list">';
        row[2].forEach(function (opt) {
          var label = d.v[opt[0]], hi = opt[1], target = hi >= 0 ? d.h[hi] : null;
          var on = hi === i, off = hi < 0;
          if (isColour) {
            var cls = 'topt__sw' + (on ? ' is-on' : '') + (off ? ' is-off' : '');
            var inner = '<span class="img"><i' + (target ? ' data-thumb="' + esc(target) + '"' : '') + '></i></span>' + esc(label);
            if (target) swatchJobs.push(target);
            html += on ? '<span role="listitem" class="' + cls + '" aria-current="true">' + inner + '</span>'
              : off ? '<span role="listitem" class="' + cls + '" aria-disabled="true" title="Not available in this combination">' + inner + '</span>'
              : '<a role="listitem" class="' + cls + '" href="/products/' + encodeURIComponent(target) + '">' + inner + '</a>';
          } else {
            html += on ? '<span role="listitem" class="topt__btn is-on" aria-current="true">' + esc(label) + '</span>'
              : off ? '<span role="listitem" class="topt__btn is-off" aria-disabled="true" title="Not available in this combination">' + esc(label) + '</span>'
              : '<a role="listitem" class="topt__btn" href="/products/' + encodeURIComponent(target) + '">' + esc(label) + '</a>';
          }
        });
        html += '</div></div>';
      });
      box.innerHTML = html;
      var sticky = document.querySelector('[data-sticky-opts]');
      if (sticky) {
        var sh = '';
        d.r[i].forEach(function (row, ri) {
          var name = d.n[row[0]], id = 'sbopt' + ri;
          sh += '<label class="sticky-buy__sel" for="' + id + '"><span>' + esc(name) + '</span><select id="' + id + '" data-sb-goto>';
          row[2].forEach(function (opt) {
            var hi = opt[1], label = d.v[opt[0]];
            if (hi === i) sh += '<option value="" selected>' + esc(label) + '</option>';
            else if (hi >= 0) sh += '<option value="/products/' + encodeURIComponent(d.h[hi]) + '">' + esc(label) + '</option>';
            else sh += '<option value="" disabled>' + esc(label) + ' (not available)</option>';
          });
          sh += '</select></label>';
        });
        sticky.innerHTML = sh;
        sticky.querySelectorAll('[data-sb-goto]').forEach(function (sel) {
          sel.addEventListener('change', function () { if (sel.value) window.location.href = sel.value; });
        });
      }
      Array.from(new Set(swatchJobs)).forEach(function (h) {
        fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p || !p.featured_image) return;
          box.querySelectorAll('[data-thumb="' + h.replace(/"/g, '') + '"]').forEach(function (el) { el.style.backgroundImage = 'url("' + thumb(p.featured_image) + '")'; });
        }).catch(function () {});
      });
    }).catch(function () {});
  });
})();